export default {
  ResellWithEbayPotentialBuyer: {
    title: {
      id: 'resell_with_ebay.where_active_soa_5.title1',
      defaultMessage: 'Where did you find this product? (Specify Seller)',
    },
  },
};
